import { atom } from "recoil";
export const settingsMenuAtom = atom({
  key: "settingsMenuAtom",
  default: false,
});
